export default "__VITE_ASSET__DhzTeh$w__"